// index.js

import React from 'react';
import ReactDOM from 'react-dom/client'; // 👈 This is important
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import './index.css';


// createRoot is the new way in React 18+
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <BrowserRouter>
    <App />
  // </BrowserRouter>
);
